import { render, staticRenderFns } from "./UltimosImoveisVenda.vue?vue&type=template&id=0a8da306&"
import script from "./ultimosImoveisVenda.js?vue&type=script&lang=js&"
export * from "./ultimosImoveisVenda.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports